(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kodak-holiday-guide"] && !Shopify.designMode) return;
  try {
    
if (window.Shopify && window.Shopify.designMode) {
  // Shopify repeats selection after a selected block is re-rendered.
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof Element)) return;

    const faq = event.target.closest('details.kh-guide__faq');
    if (faq) faq.open = true;
  });
}

  } catch(e) { console.error(e); }
})();
})();
